import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/onboarding/$onboardingId")({
  beforeLoad: () => {
    throw redirect({ to: "/explore" });
  },
});
